import { useEffect, useState, useCallback } from 'react';
import { Modal, Box } from '@mui/material';
import strings from '../../strings/strings.json'
import { useDropzone } from 'react-dropzone'
import VolCalculator from 'components/vol_calculator/vol_calculator';
import { addYaraRule } from 'api/api_service';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: '0 1px 60px 0 rgba(155, 181, 190, 0.2)',
    borderRadius: '14px',
    p: 4,
};

interface Props {
    /*    data: any, */
    openModal: boolean,
    onCloseModal: () => void,
    confirmClicked: () => void
}

export default function ChooseYaraModal(props: Props) {

    const dispatch = useDispatch();
    const [fileData, setFileData] = useState<any>()

    const onDrop = useCallback(acceptedFiles => {
        setFileData(acceptedFiles[0])
    }, [])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    const handleCloseModal = () => {
        props.onCloseModal()
    }

    const removeFileClickHandler = () => {
        setFileData(undefined)
    }

    const confirmHandler = () => {
        const formData = new FormData()
        if (fileData !== undefined) {
            formData.append("rule", fileData)
            addYaraRule(formData)
                .then(res => {
                    if (res.data.success) {
                        props.confirmClicked()
                        cancelHandler()
                        dispatch(showSnackbar({ "open": true, severity: "success", msg: `${strings.public_operationDone}` }));
                    }
                })
        }

    }

    const cancelHandler = () => {
        props.onCloseModal()
        setFileData(undefined)
    }

    return (
        <Modal
            open={props.openModal}
            onClose={handleCloseModal}>
            <Box sx={style}>
                <div className='flex justify-center flex-col items-center'>
                    <div className='text-2xl font-bold'>{strings.public_chooseFile}</div>
                    <div className='text-xs mt-2 font-medium secondry_text_color'>{strings.public_yaraSubTitle}</div>
                    {
                        fileData == undefined ?
                            (
                                <div className='flex flex-col w-full justify-center mt-4'>
                                    <div {...getRootProps()} className=''>
                                        <input {...getInputProps()} />
                                        <div className='flex flex-col items-center mt-5 border border-dashed py-4 rounded-lg border-gray-300'>
                                            <span className='text-xs secondry_text_color font-medium'>{strings.public_dragFile}</span>
                                            <button className='rounded-full mt-5 border border-black px-10 py-2 text-xs'>{strings.public_chooseFile}</button>
                                        </div>
                                    </div>
                                </div>
                            )
                            :
                            (
                                <div className='flex justify-between w-full items-center mt-4'>
                                    <img className='w-5 cursor-pointer' src={require('../../assets/icons/delete_red.svg').default} alt="Icon" onClick={() => removeFileClickHandler()} />
                                    <div className='flex flex-col items-end text-left'>
                                        <div className='text-xs primary_text_color w-96 truncate'>{fileData.name}</div>
                                        <span className='text-xs secondry_text_color'>{VolCalculator.calculate(fileData.size)}</span>
                                    </div>
                                </div>
                            )
                    }
                    {
                        <div className='flex justify-between pt-5 px-6 mt-5 border-t border-t-gray-100 w-full'>
                            <button disabled={fileData !== undefined ? false : true} className={`${fileData === undefined ? 'cursor-not-allowed' : 'cursor-pointer'} text-white w-28 rounded-full px-8 py-2 primary_bg_color text-xs`} onClick={() => confirmHandler()}>{strings.public_confirm}</button>
                            <button className='rounded-full w-28 border border-black px-8 py-2 text-xs' onClick={() => cancelHandler()}> {strings.public_cancel}</button>
                        </div>
                    }
                </div>
            </Box>
        </Modal>
    )
}
